var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.container }, [
    _c(
      "div",
      { class: _vm.$style.state },
      [
        _vm.isWorking
          ? _c("rb-loading", { attrs: { "rb-class": "medium" } })
          : [
              _c(
                "button",
                {
                  staticClass: "icon",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("click")
                    },
                  },
                },
                [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      class: _vm.checkbox.style,
                    },
                    [_vm._v(_vm._s(_vm.checkbox.icon))]
                  ),
                ]
              ),
              _c("div", {
                staticClass: "rbTooltip simple",
                class: _vm.$style.tooltip,
                attrs: { tooltip: "placement:top-start" },
                domProps: { innerHTML: _vm._s(_vm.htmlCheckboxTooltip) },
              }),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }